
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4layl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e32e2e9e61612bcf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $e32e2e9e61612bcf$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0440\u0435\u0430\u043A\u0446\u0438\u044E",
    'fabric.reactions.error.unexpected': "\u0420\u0435\u0430\u043A\u0446\u0438\u0438 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B",
    'fabric.reactions.loading': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
    'fabric.reactions.more.emojis': "\u0414\u0440\u0443\u0433\u0438\u0435 \u044D\u043C\u043E\u0434\u0437\u0438",
    'fabric.reactions.other.reacted.users': "{count, plural, one {\u0438 \u0435\u0449\u0435 \u043E\u0434\u0438\u043D} few {\u0438 \u0435\u0449\u0435 {count}} many {\u0438 \u0435\u0449\u0435 {count}} other {\u0438 \u0435\u0449\u0435 {count}}}",
    'fabric.reactions.reactwithemoji': "\u041E\u0442\u0440\u0435\u0430\u0433\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u044D\u043C\u043E\u0434\u0437\u0438 {emoji}",
    'fabric.reactions.summary': "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u0440\u0435\u0430\u043A\u0446\u0438\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439",
    'reaction-picker-trigger.add.reaction.message': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0440\u0435\u0430\u043A\u0446\u0438\u044E",
    'reactions.dialog.close': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'reactions.dialog.left.navigate': "\u041D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u044F \u0432\u043B\u0435\u0432\u043E",
    'reactions.dialog.reactions.count': "{count, plural, one {\u0412\u0441\u0435\u0433\u043E \u0440\u0435\u0430\u043A\u0446\u0438\u0439: {count,number}} few {\u0412\u0441\u0435\u0433\u043E \u0440\u0435\u0430\u043A\u0446\u0438\u0439: {count,number}} many {\u0412\u0441\u0435\u0433\u043E \u0440\u0435\u0430\u043A\u0446\u0438\u0439: {count,number}} other {\u0412\u0441\u0435\u0433\u043E \u0440\u0435\u0430\u043A\u0446\u0438\u0439: {count,number}}}",
    'reactions.dialog.right.navigate': "\u041D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u044F \u0432\u043F\u0440\u0430\u0432\u043E",
    'reactions.dialog.viewall': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435",
    'reactions.dialog.viewall.tooltip': "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u0440\u0435\u0430\u043A\u0446\u0438\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439"
};

});


//# sourceMappingURL=ru.c00f5b56.js.map
